(() => {
  const openGalleryItem = (trigger) => {
    const root = trigger.closest("[data-dd-gallery-root]");
    const dialog = root?.querySelector("[data-dd-gallery-dialog]");
    const image = dialog?.querySelector("[data-dd-gallery-dialog-image]");
    const caption = dialog?.querySelector("[data-dd-gallery-dialog-caption]");

    if (!dialog || !image || !caption) return;

    image.src = trigger.dataset.src;
    image.alt = trigger.dataset.alt || "";
    caption.textContent = trigger.dataset.caption || "";

    if (typeof dialog.showModal === "function") {
      dialog.showModal();
    } else {
      dialog.setAttribute("open", "");
    }
  };

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-dd-gallery-open]");
    if (trigger) {
      openGalleryItem(trigger);
      return;
    }

    const dialog = event.target.closest("[data-dd-gallery-dialog]");
    if (dialog && event.target === dialog) {
      dialog.close();
    }
  });
})();
